import { Modal, Alert, Button } from "react-bootstrap";
import './CodeSearch.css';

const WarningPanel = ({ show, clusterCodeWarningsList =[], clusterCodeWarningsErrorList= [], onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg"  backdropClassName="warning-backdrop"
  contentClassName="warning-modal">
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">
          ⚠️ DCID case identified. Kindly review and confirm.
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "350px", overflowY: "auto" }}>
        {clusterCodeWarningsList.map((w, index) => (
          <Alert key={index} variant="warning" className="mb-2">
            {w}
          </Alert>
        ))}
        {clusterCodeWarningsErrorList.map((w, index) => (
          <Alert key={index} variant="danger" className="mb-2">
            {w}
          </Alert>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WarningPanel;
